<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="手机号邀请推广"
    width="500px"
    
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">
        <el-form-item label="手机号" prop="mobile" >  
          <el-input  type="text" v-model="formData.mobile" placeholder="输入手机号添加推广"></el-input> 
        </el-form-item>
     
      </el-form>

    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>


  </el-dialog>
</template>

<script>
import {mobileAddPopularizeApi } from  "@/api/relation/index.js";

export default {
  components: { },

  data() {
    return {
      visible: false,
      userList:[],
      formData: {
        mobile:"",
      },
       rules: {
        mobile: [
              {required: true, message: '请输入手机号', trigger: 'blur'}
          ],
       }
    };
  },

 
  mounted() {
    console.log("asdasdasd")

},
  
  methods: {
  
    handleClose() {
      this.$refs["form"].resetFields();
      this.visible = false;

    },


    init() {
      this.visible = true;
    },

   
    
    
    submit(){
      var that=this;

      this.$refs["form"].validate((valid) => {
          if (valid) {
            mobileAddPopularizeApi(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'

                });
                that.$emit('refresh');
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });

    },

    
  },

 
};
</script>

<style lang="scss" scoped>



::v-deep .myWindow {
    border-radius: 15px;



/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }

  .table_form {
    width: 100%;
    height: 68px;
    box-sizing: border-box;
    border-radius: 6px;
    border: 1px solid #cccccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin-bottom: 19px;
  section {
    display: flex;
    img {
      width: 43px;
      height: 43px;
      margin-right: 15px;
    }
    div {
      height: 43px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      b {
        font-size: 16px;
        color: #333;
      }
      span {
        font-size: 11px;
        margin-right: 20px;
        color: #666;
      }
    }
  }
}
</style>
